<template>
	<div>
		<div style="overflow:auto !important;height: 90vh;">
			<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
				<!-- 			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.deviceNum" placeholder="设备编号/IMEI/MAC" >
						<span slot="prepend">充电站</span>
					</Input>
			</FormItem> -->
				<FormItem prop="trackName" label="充电站:" :label-width="100">
					<Select placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
						<Option :value=0>全部</Option>
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
							{{item.StationName}}
						</Option>
						<!-- <span slot="prepend">联系电话</span> -->
					</Select>
				</FormItem>
				<FormItem prop="trackName" label="设备编号:" :label-width="100">
					<Input type="text" v-model="formInline.EquipmentNo" placeholder="设备编号" />
				</FormItem>
				<FormItem v-if='Control.select'>
					<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
				</FormItem>
			</Form>
			<Card style="margin-bottom: 20px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;">
				<Row>
					<Col span="5">
					<Tag color="#5500ff" type="dot" size="large" style="font-size: 18px;">枪总数量{{Summary.Total}}</Tag>
					</Col>
					<Col span="5">
					<Tag color="primary" type="dot" size="large" style="font-size: 18px;">充电总数量{{Summary.Charging}}</Tag>
					</Col>
					<Col span="5">
					<Tag color="success" type="dot" size="large" style="font-size: 18px;">待机总数量{{Summary.Standby}}</Tag>
					</Col>
					<Col span="5">
					<Tag color="#bbbbbb" type="dot" size="large" style="font-size: 18px;">离线数量{{Summary.Offline}}</Tag>
					</Col>
					<Col span="4">
					<Tag color="#ed4e4c" type="dot" size="large" style="font-size: 18px;">故障数量{{Summary.Alarming}}</Tag>
					</Col>
				</Row>
			</Card>
			<template v-for="(statusItem, idx) in statusList">
				<div :key="idx" style="margin-bottom: 20px; text-align: left;">
					<Tag slot="title" class="label" :color="statusItem.color" type="dot">{{statusItem.statusDesc}}</Tag>
					<Row :gutter="12" type="flex" justify="start" class="chargeCardClass">
						<Col class="col-24 col-md-12 col-lg-8 col-xxl-6 col-xxl-5 col-xxl-4" v-bind:key="index"
							v-for="(item, index) in statusItem.statusData">
						<Card :class="titleColor(item.WorkStatus)">
							<p slot="title">
								<!-- <span class="tag" style="font-size: 0.46875rem;">{{item.ConnectorType!=3?'交':'直'}}</span> -->
								<span class="1" style="font-size: 1rem;">{{item.ConnectorType==4?'DC |':'AC |'}}</span>
								<span style="font-size: 1rem;">
									{{item.ConnectorNo}}{{item.EquipmentSerialNo ?'/':''}}{{item.EquipmentSerialNo}}</span>
							</p>
							<a style="color: #000000;font-size: 0.75rem;" href="#" slot="extra"
								@click.prevent="detail(item.ConnectorNo,item.WorkStatus)">
								<!-- <Icon type="ios-loop-strong"></Icon> -->
								<Icon type="ios-browsers-outline" size="24" color="white" />
							</a>
							<div class="freeDiv">
								<div class="cicle_p circle-div">
									<i-circle :percent="100" :size="72" :stroke-color="circleColor(item.WorkStatus)" :stroke-width="8"
										:trail-width="8">
										<p :style="circleTextColor(item.WorkStatus)">{{item.WorkStatusDesc}}</p>
										<p v-if="item.ConnectorType==4 && item.WorkStatus == 2" :style="'font-size:1rem;margin-top: 5px;' + circleTextColor(item.WorkStatus)">
											{{item.CurrentSoc}}%
										</p>
									</i-circle>
								</div>
								<div class="statusCard">
									<div v-if="item.WorkStatus == 2">
										<!-- <Col span="24"> -->
										<Row style="margin-bottom: 10px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />充电电压:
											</span>
											<span>{{item.ChargeVoltage}} V</span>
											</Col>
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />充电电流:
											</span>
											<span>
												{{item.ChargeCurrent}} A
											</span>
											</Col>
										</Row>
										<Row style="margin-bottom: 10px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />已充时长:
											</span>
											<span>
												{{item.ChargeDurationDesc}}
											</span>
											</Col>
											<!-- <Col span="12" v-if="item.ConnectorType!=3">
												<span>
													<Icon type="ios-pricetag" size="15" />实时功率:
												</span>
												<span>
													{{item.CurrentSoc}}kW
												</span>
												</Col> -->
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />实时功率:
											</span>
											<span>
												{{item.ChargePower.toFixed(2)}} kW
											</span>
											</Col>
										</Row>
										<Row style="margin-bottom: 10px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />已充电量:
											</span>
											<span>
												{{item.ChargeKwh}} kWh
											</span>
											</Col>
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />已充金额:
											</span>
											<span>
												{{item.ChargeCost}} 元
											</span>
											</Col>
										</Row>
										<!-- </Col> -->
									</div>
									<div v-else>
										<!-- <Col span="24"> -->
										<Row style="text-align: left;" v-if="item.WorkStatus==6">
											<Col span="24">
											<span>
												告警描述：
											</span>
											<span>
												{{item.MaxAlarmDesc}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==0">
											<Col span="24">
											<span>
												插枪状态：
											</span>
											<span>
												{{item.CarCoupleStatusDesc}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==3">
											<Col span="24">
											<span>
												插枪状态：
											</span>
											<span>
												{{item.CarCoupleStatusDesc}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==-1">
											<Col span="24">
											<span>
												离线时间：
											</span>
											<span>
												{{item.OfflineTime}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else>
											<Col span="24">
											<span>
												插枪状态：
											</span>
											<span>
												{{item.CarCoupleStatusDesc}}
											</span>
											</Col>
										</Row>
										<!-- </Col> -->
									</div>
								</div>
							</div>
						</Card>
						</Col>
					</Row>
					<Button type="dashed" long v-on:click="showMore(idx)"
						:disabled="isAllShowed(idx)">{{ statusItem.statusData.length == statusItem.statusDataTotal.length ? '已加载全部' : '加载更多' }}
					</Button>
				</div>
			</template>
			<Modal v-model="showModel" title="设备状态详情" width="80%">
				<Tabs value="name1">
					<TabPane label="设备状态" name="name1">
						<Table :columns="columns1" :data="dataDetail" ref="table" size="small"></Table>
					</TabPane>
					<TabPane label="订单情况" name="name2">
						<Table :columns="columns2" :data="dataDetail" v-if="tableShow" ref="table2" size="small"></Table>
					</TabPane>
				</Tabs>
			</Modal>
			<!-- <MyPage ref="sonPage" :param="pageParam" :url="getEqumentStatusBaseUrl" @listData='getDeviceData'></MyPage> -->
		</div>
	</div>
</template>

<script>
	// import echarts1 from "../../../js/echarts_hot.js";
	// import dateFormat from '../../../../public/js/comm.js'
	// import Qs from 'qs'
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';

	export default {
		data() {
			//自定义表单验证
			// const latlng = (rule, value, callback) => {
			// 	var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;

			// 	if (!latreg.test(value)) {
			// 		callback(new Error("请填写正确经纬度格式"));
			// 	} else {
			// 		callback();
			// 	}
			// };
			return {
				getEqumentStatusBaseUrl: webapi.base_api_url + '/Operations/GetEqumentStatusBase',
				Control: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//详情model
				showModel: false,
				//model中两个table显示
				tableShow: true,
				tableHeight: "650",
				//充电设备总计
				Summary: {
					Total: 0,
					Charging: 0,
					Standby: 0,
					Offline: 0,
					Alarming: 0,
				},
				BreadcrumbList: ['场站监控', '>>', '设备状态'],
				formInline: {
					StationId: 0,
					EquipmentNo: ''
				},
				//table1标题数据
				columns1: [{
						title: '设备编号',
						key: 'EquipmentNo',
					}, {
						title: '设备名称',
						key: 'EquipmentName',
					},
					{
						title: '枪编号',
						key: 'ConnectorNo'
					},
					{
						title: '枪名称',
						key: 'ConnectorName'
					},
					{
						title: '设备类型',
						key: 'EquipmentType',
						render: (h, params) => {
							let type = ''
							switch (params.row.EquipmentType) {
								case 1:
									type = "直流设备"
									break;
								case 2:
									type = "交流设备"
									break;
								case 3:
									type = "交直流一体设备"
									break;
								case 4:
									type = "无线设备"
									break;
								default:
									type = "其他"
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: '枪类型',
						key: 'ConnectorType',
						width: 300,
						render: (h, params) => {
							let type = ''
							switch (params.row.ConnectorType) {
								case 1:
									type = "家用插座（模式2）"
									break;
								case 2:
									type = "交流接口插座（模式3，连接方式B ）"
									break;
								case 3:
									type = "交流接口插头（带枪线，模式3，连接方式C）"
									break;
								case 4:
									type = "直流接口插头（带枪线，模式4）"
									break;
								case 5:
									type = "大功率交流接口插头"
									break;
								default:
									type = "其他"
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: '工作状态',
						key: 'WorkStatus',
						render: (h, params) => {
							let type = ''
							switch (params.row.WorkStatus) {
								case 0:
									type = "空闲"
									break;
								case 1:
									type = "充电启动中"
									break;
								case 2:
									type = "充电中"
									break;
								case 6:
									type = "故障"
									break;
								case -1:
									type = "离线"
									break;
								default:
									type = "其他"
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: '最高告警码',
						key: 'MaxAlarmCode',
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.MaxAlarmCode) {
								case 0:
									color = "success",
										type = "无告警"
									break;
								default:
									color = "error",
										type = params.row.MaxAlarmDesc
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: '连接状态',
						key: 'CarCoupleStatus',
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "error",
										type = "未连接"
									break;
								default:
									color = "success",
										type = "已连接"
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: '额定功率',
						key: 'RatedPower'
					},
					{
						title: '站点名称',
						key: 'StationName'
					}
				],
				//table2标题数据
				columns2: [{
						title: '充电订单号',
						key: 'OrderNo',
						width: 260
					}, {
						title: '充电开始时间',
						key: 'ChargeStartTime',
						width: 160
					},
					{
						title: '充电启动方式',
						key: 'StartModeDesc',
						width: 110
					},
					{
						title: '充电电压',
						key: 'ChargeVoltage',
						width: 110
					},
					{
						title: '充电电流',
						key: 'ChargeCurrent',
						width: 110
					},
					{
						title: '充电时长',
						key: 'ChargeDuration',
						width: 110,
						render: (h, params) => {
							return h('div',
								params.row.ChargeDurationDesc
							);
						}
					},
					{
						title: '充电功率',
						key: 'ChargePower',
						width: 110,
					},
					{
						title: '已充电量',
						key: 'ChargeKwh',
						width: 110,
					},
					{
						title: '已充费用',
						key: 'ChargeCost',
						width: 110,
					},
					{
						title: '当前SOC',
						key: 'CurrentSoc',
						width: 110,
					},
					{
						title: '剩余时长',
						key: 'StationName',
						width: 110,
						render: (h, params) => {
							return h('div',
								params.row.RemainDurationDesc
							);
						}
					},
					{
						title: '充电卡编号',
						key: 'CardNo',
						width: 270
					},
					{
						title: '手机号码',
						key: 'MemberPhone',
						width: 110,
					},
					{
						title: '会员名称',
						key: 'MemberName',
						width: 110,
					},
					{
						title: '电池温度',
						key: 'BatteryTemp',
						width: 110,
					},
					{
						title: '枪温度',
						key: 'ConnectorTemp',
						width: 110,
					},
					{
						title: '汽车VIN码',
						key: 'VIN',
						width: 110,
					}
				],
				dataCharging: [],
				dataStandby: [],
				dataFault: [],
				dataOffline: [],
				dataDetail: [],
				statusList: [{
					statusDesc: '充电',
					color: '#2d8cf0',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '空闲',
					color: '#19be6b',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '故障',
					color: '#ed4e4c',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '离线',
					color: '#aaaaaa',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}],
				timer: ''
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
		},
		activated() {
			let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			this.Control = col.control
			// console.log(col.control);
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		updated() {},
		mounted() {
			const _this = this;
			this.$nextTick(function() {
				// 仅在整个视图都被渲染之后才会运行的代码
				// setTimeout(() => {
				// 	if (_this.StationList) _this.formInline.StationId = _this.StationList[0].StationId;
				_this.handleSubmit();
				// }, 1000);
			})
			//_this.getButton()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		computed: {
			getCircleSize: function() {
				//console.log(document.body.clientWidth / 60 + 'px')
				return document.body.clientWidth / 12
			},
			// deviceCharging: function() {
			// 	const _this = this;
			// 	return _this.data1.filter(obj => obj.WorkStatus == 2);
			// 	// _this.data1.forEach(function(x, index, a) {
			// 	// 	let type = '';
			// 	// 	switch (x.WorkStatus) {
			// 	// 		case 0:
			// 	// 			type = "空闲"
			// 	// 			break;
			// 	// 		case 1:
			// 	// 			type = "充电启动中"
			// 	// 			break;
			// 	// 		case 2:
			// 	// 			type = "充电中"
			// 	// 			break;
			// 	// 		case 6:
			// 	// 			type = "故障"
			// 	// 			break;
			// 	// 		case -1:
			// 	// 			type = "离线"
			// 	// 			break;
			// 	// 		default:
			// 	// 			type = "其他"
			// 	// 			break;
			// 	// 	}
			// 	// 	x.WorkStatus = type;
			// 	// });
			// 	// return _this.data1;
			// },
			// deviceStandby: function() {
			// 	const _this = this;
			// // 	_this.data2.forEach(function(x, index, a) {
			// // 		let type = '';
			// // 		switch (x.WorkStatus) {
			// // 			case 0:
			// // 				type = "空闲"
			// // 				break;
			// // 			case 1:
			// // 				type = "充电启动中"
			// // 				break;
			// // 			case 2:
			// // 				type = "充电中"
			// // 				break;
			// // 			case 3:
			// // 				type = "充电完成"
			// // 				break;
			// // 			case 4:
			// // 				type = "启动失败"
			// // 				break;
			// // 			case 6:
			// // 				type = "故障"
			// // 				break;
			// // 			case -1:
			// // 				type = "离线"
			// // 				break;
			// // 			default:
			// // 				type = "其他"
			// // 				break;
			// // 		}
			// // 		x.WorkStatus = type;
			// // 	});
			// // 	return _this.data2;
			// },
			pageParam: function() {
				const _this = this;
				const param = _this.formInline
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
			}),
			//当基础属性需要过率时候
			// ...mapGetters([
			// 	'getPageUserButton'
			// ])
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				//this.$refs.sonPage.getList();
				const _this = this
				const params = _this.formInline;
				params.page = 0;
				params.pageSize = 0;
				_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusBase', params).then(res => {
					if (res.data.code != 1) {
						_this.dataCharging = res.data.Data.List.filter((currentValue) => currentValue.WorkStatus === 2);

						// 充电中
						let idx = 0;
						_this.statusList[idx].statusDataTotal = _this.dataCharging = res.data.Data.List.filter((
							currentValue) => currentValue.WorkStatus == 2);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// 空闲
						idx++
						_this.statusList[idx].statusDataTotal = _this.dataStandby = res.data.Data.List.filter((
							currentValue) => {
							return currentValue.WorkStatus != 2 && currentValue.WorkStatus != 6 && currentValue.WorkStatus !=
								-1;
						});
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// 故障
						idx++;
						_this.statusList[idx].statusDataTotal = _this.dataFault = res.data.Data.List.filter((currentValue) =>
							currentValue.WorkStatus == 6);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// 离线
						idx++;
						_this.statusList[idx].statusDataTotal = _this.dataOffline = res.data.Data.List.filter((currentValue) =>
							currentValue.WorkStatus == -1);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));
						this.Summary = res.data.Data.Summary;
					}
				})
			},
			showMore(idx) {
				const _this = this;
				_this.statusList[idx].showNum += 20;
				_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this.statusList[idx]
					.showNum, _this.statusList[idx].statusDataTotal.length));
			},
			isAllShowed(idx) {
				const _this = this;
				return _this.statusList[idx].statusData.length == _this.statusList[idx].statusDataTotal.length;
			},
			detail: function(ConnectorNo, WorkStatus) {
				const _this = this
				const params = {
					ConnectorNo: ConnectorNo
				}
				_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusDetail', params).then(res => {
					if (res.data.code != 1) {
						_this.dataDetail = [];
						_this.dataDetail.push(res.data.Data.Detail);
					}
				})
				//充电中才会显示订单详情table
				if (WorkStatus == 2) {
					_this.tableShow = true
				} else {
					_this.tableShow = false
				}
				_this.showModel = true
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 300;
			},
			titleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "free cardTitleGreen"
						break;
					case 1:
						titleClass = "free cardTitleBlue"
						break;
					case 2:
						titleClass = "free cardTitleBlue"
						break;
					case 6:
						titleClass = "free cardTitleRed"
						break;
					case -1:
						titleClass = "free cardTitleGrey"
						break;
					default:
						titleClass = "free cardTitleGreen"
						break;
				}
				return titleClass;
			},
			circleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "#19be6b"
						break;
					case 1:
						titleClass = "#2d8cf0"
						break;
					case 2:
						titleClass = "#2d8cf0"
						break;
					case 6:
						titleClass = "#ed4e4c"
						break;
					case -1:
						titleClass = "#bbbbbb"
						break;
					default:
						titleClass = "#19be6b"
						break;
				}
				return titleClass;
			},
			circleTextColor: function(WorkStatus) {
				let titleClass = 'font-size:1rem;';
				switch (WorkStatus) {
					case 0:
						titleClass += "color:#19be6b"
						break;
					case 1:
						titleClass += "color:#2d8cf0"
						break;
					case 2:
						titleClass += "color:#2d8cf0"
						break;
					case 6:
						titleClass += "color:#ed4e4c"
						break;
					case -1:
						titleClass += "color:#bbbbbb"
						break;
					default:
						titleClass += "color:#19be6b"
						break;
				}
				return titleClass;
			},
		},
	}
</script>

<style scoped>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.col-24 {
		flex: 0 0 100%;
		max-width: 100%;
	}

	@media (min-width: 1100px) {
		.col-md-12 {
			flex: 0 0 50%;
			max-width: 50%;
		}
	}

	@media (min-width: 1380px) {
		.col-lg-8 {
			flex: 0 0 33.33333333%;
			max-width: 33.33333333%;
		}
	}

	@media (min-width: 1760px) {
		.col-xxl-6 {
			flex: 0 0 25%;
			max-width: 25%;
		}
	}

	@media (min-width: 2140px) {
		.col-xxl-5 {
			flex: 0 0 20%;
			max-width: 20%;
		}
	}

	@media (min-width: 2520px) {
		.col-xxl-4 {
			flex: 0 0 16.66666666666667%;
			max-width: 16.66666666666667%;
		}
	}

	/deep/.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	/deep/.normal {
		margin-bottom: 20px;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 90% !important;
		height: 160px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	/deep/.normal .ivu-card-head {
		background-image: linear-gradient(#3FD983, #3aca79);
	}

	/deep/.normal .ivu-card-body {
		padding: 0px 10px;
	}

	/deep/.free {
		margin-bottom: 12px;
		box-shadow: 2px 2px 4px #a7a7a7;
		/* width: 90% !important; */
		height: 150px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	/deep/.free .ivu-card-body {
		padding: 0px 10px;
	}

	/deep/.cardTitleBlue .ivu-card-head {
		background-image: linear-gradient(#4d9ae7, #55aaff);
	}

	/deep/.cardTitleRed .ivu-card-head {
		background-image: linear-gradient(#ed4e4c, #ed7f7c);
	}

	/deep/.cardTitleGrey .ivu-card-head {
		background-image: linear-gradient(#bbbbbb, #dddddd);
	}

	/deep/.cardTitleGreen .ivu-card-head {
		background-image: linear-gradient(#19be6b, #4ad697);
	}

	/deep/.ivu-card-head p {
		text-align: left;
		color: white;
	}

	/deep/.freeDiv {
		text-align: center;
		height: 100px;
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	/deep/.freeDiv .ivu-chart-circle-inner {
		/* top: 1.1875rem; */
	}

	/deep/.ivu-chart-circle-inner p {
		font-size: 0.46875rem;
	}

	/deep/.chargeCardClass .ivu-col-span-7 {
		margin-left: 0px;
	}

	/deep/.ivu-chart-circle {
		/* width: 2.8125rem !important; */
		/* height: 2.8125rem !important; */
	}

	/deep/.circle-div {
		float: left;
		width: 22%;
		height: 100%;
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 1rem;
	}

	/deep/.statusCard {
		font-size: 0.75rem;
		width: 78%;
		float: right;
		height: 100px;
		padding: 0px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex: 1;
	}

	/deep/.tag {
		background-color: #2d8cf0;
		padding: 0px 2px 0px 2px;
		border-radius: 2px;
	}

	/deep/.label {
		background: transparent !important;
		padding-left: 0;
	}

	/deep/.label .ivu-tag-dot-inner {
		margin-right: 0;
		height: 15px;
		width: 15px;
	}

	/deep/.label .ivu-tag-text {
		font-size: 20px;
	}

	/deep/.loginBg .ivu-card-bordered,
	.ivu-card {
		margin-right: 0;
	}
</style>
